"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _ramda = require("ramda");

var _reactIntl = require("react-intl");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require("./propTypes");

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/** Installments component */


var Installments = /*#__PURE__*/function (_Component) {
  _inherits(Installments, _Component);

  function Installments() {
    _classCallCheck(this, Installments);

    return _possibleConstructorReturn(this, _getPrototypeOf(Installments).apply(this, arguments));
  }

  _createClass(Installments, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showLabels = _this$props.showLabels,
          formatNumber = _this$props.formatNumber,
          installments = _this$props.installments,
          currencyOptions = _this$props.currencyOptions,
          className = _this$props.className,
          installmentClass = _this$props.installmentClass,
          interestRateClass = _this$props.interestRateClass;

      if (!installments || (0, _ramda.isEmpty)(installments)) {
        return null;
      }

      var noInterestRateInstallments = installments.filter(function (installment) {
        return !installment.InterestRate;
      });
      /*
       * - The selected installment will be the one with the highest `NumberOfInstallments`;
       * - If there is no 'interest-free' installments, the normal installments will be analyzed.
       */

      var installment = ((0, _ramda.isEmpty)(noInterestRateInstallments) ? installments : noInterestRateInstallments).reduce(function (previous, current) {
        return previous.NumberOfInstallments > current.NumberOfInstallments ? previous : current;
      });
      var formattedInstallmentPrice = formatNumber(installment.Value, currencyOptions);

      var _map = [installment.NumberOfInstallments, formattedInstallmentPrice, _react2["default"].createElement(_react.Fragment, null, "x")].map(function (element, index) {
        return _react2["default"].createElement("span", {
          className: installmentClass,
          key: index
        }, element);
      }),
          _map2 = _slicedToArray(_map, 3),
          installmentsElement = _map2[0],
          installmentPriceElement = _map2[1],
          timesElement = _map2[2];

      return _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-installments__container', className)
      }, showLabels ? _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "pricing.installment-display",
        values: {
          installments: installmentsElement,
          installmentPrice: installmentPriceElement,
          times: timesElement
        }
      }) : _react2["default"].createElement(_react.Fragment, null, installmentsElement, timesElement, " ", installmentPriceElement), !installment.InterestRate && _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-installments__interest-rate', interestRateClass)
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "pricing.interest-free"
      })));
    }
  }]);

  return Installments;
}(_react.Component);

_defineProperty(Installments, "propTypes", {
  /** Classes to be applied to the root element */
  className: _propTypes2["default"].string,

  /** Classes to be applied to installment value element */
  installmentClass: _propTypes2["default"].string,

  /** Classes to be applied to interest rate element */
  interestRateClass: _propTypes2["default"].string,

  /** Product installments to be displayed */
  installments: _propTypes4["default"].installments,

  /** Pages editor config to display labels */
  showLabels: _propTypes2["default"].bool.isRequired,

  /** react-intl function to format the prices*/
  formatNumber: _propTypes2["default"].func.isRequired,

  /** Options to be passe to the formatNumber function*/
  currencyOptions: _propTypes2["default"].shape({
    style: _propTypes2["default"].string.isRequired,
    currency: _propTypes2["default"].string.isRequired,
    minimumFractionDigits: _propTypes2["default"].number.isRequired,
    maximumFractionDigits: _propTypes2["default"].number.isRequired
  }).isRequired
});

exports["default"] = Installments;